import { fetchWithAuth } from "@/lib/api";
import { getAccessTokenDirect } from "@/lib/auth0";

export type OrdersListParams = {
  page: number;
  pageSize: number;
  startDate: string; // ISO
  endDate: string; // ISO
  brandId?: number;
  branchId?: number;
  status?: string;
  searchTerm?: string;
};

export async function listOrders(params: OrdersListParams) {
  const token = await getAccessTokenDirect();
  const sp = new URLSearchParams();
  sp.set("page", String(params.page));
  sp.set("pageSize", String(params.pageSize));
  sp.set("startDate", params.startDate);
  sp.set("endDate", params.endDate);
  if (params.brandId) sp.set("brandId", String(params.brandId));
  if (params.branchId) sp.set("branchId", String(params.branchId));
  if (params.status && params.status !== "all") sp.set("status", params.status);
  if (params.searchTerm && params.searchTerm.trim() !== "")
    sp.set("searchTerm", params.searchTerm.trim());

  return fetchWithAuth(`/order/orders?${sp.toString()}`, token);
}

export async function getOrdersCounts(params?: {
  date?: string; // YYYY-MM-DD (El Salvador local date)
  brandId?: number;
  branchId?: number;
}) {
  const token = await getAccessTokenDirect();
  const sp = new URLSearchParams();
  if (params?.date) sp.set("date", params.date);
  if (params?.brandId) sp.set("brandId", String(params.brandId));
  if (params?.branchId) sp.set("branchId", String(params.branchId));
  return fetchWithAuth(
    `/order/orders/counts${sp.toString() ? `?${sp.toString()}` : ""}`,
    token,
  );
}

export async function getOrderDetail(id: number | string) {
  const token = await getAccessTokenDirect();
  return fetchWithAuth(`/order/orders/${id}`, token);
}
